import { Box, H3, P, ShortSplitter } from '@landsbankinn/ui-kit';

export function MobileTitleAndDescription({
  title,
  description,
  paddingHorizontal = '36',
}: {
  title: string;
  description?: string;
  paddingHorizontal?: '36' | '0';
}) {
  return (
    <Box
      paddingTop="40"
      paddingHorizontal={paddingHorizontal}
      paddingBottom="20"
    >
      <Box paddingVertical="20">
        <H3 fontVariant="h3">{title}</H3>
      </Box>
      {description && (
        <>
          <ShortSplitter height="32" />
          <Box paddingVertical="20">
            <P fontVariant="body">{description}</P>
          </Box>
        </>
      )}
    </Box>
  );
}
